/**
* @summary - Component that Provides OtherRespondedDetails Edit for Vendor Work Order
* @author Yuvasri S
* @since 2024-09-11
*/
import React, { useState, useEffect } from 'react';
import { DefaultCard } from '../../assets/styled-components/card';
import { Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import { useDispatch } from 'react-redux';
import { getWebFormVendorName, updateothereRespondedDetails } from '../../redux/actions/vendor/webFormActions';
import CustomTextField from '../commoncomponents/CustomTextField';
import workOrderSummaryRepositry from '../../api/repositories/workOrderSummaryRepositries';
import PageLoader from '../commoncomponents/PageLoader';
import { useLocation } from 'react-router-dom';

const OtherRespondedDetailsEditForm = ({ locationState, responseData, onOtherDetailsChange,errorState,errorMesaage,responderrorstate,responderrormessage }) => {


    const assetCategoryType = locationState?.serviceType || ""
    const serviceType = assetCategoryType === "FEMS" ? "fem" : "bem";
    const categoryType = locationState?.categoryType;
    const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
    const [otherRespondedDetails, setOtherRespondedDetails] = useState({
        selectedPartsRequired: "",
        assessmentId: "",
        selectedAssetTakenOut: "",
        outsourceRespondRemarks: "",
        respondFinding:"",
    });
    const [vendorIdToLabelMap, setVendorIdToLabelMap] = useState(new Map());
    const [vendorName, setVendorName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const getstatusId = assetCategoryType === "FEMS" ? location?.state?.femworkorderstatusId : location?.state?.bemworkorderstatusId;
    const checkstatus = [4,5,8,9].includes(getstatusId) ? true : false;

    useEffect(() => {
        if (responseData) {
            setIsLoading(true);
            const isPartsRequired = responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.ispartsrequired === true
                ? 'yes'
                : responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.ispartsrequired === false
                    ? 'no'
                    : ""
           const isAssetTakenOutLocation = responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.isassettakenoutlocation === true
                ? 'yes'
                : responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.isassettakenoutlocation === false
                    ? 'no'
                    : ""
            const updateRespondedeDetails = {
                assessmentId: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.id || '',
                selectedPartsRequired: isPartsRequired,
                selectedAssetTakenOut: isAssetTakenOutLocation,
                outsourceRespondRemarks: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.respondremarks || '',
                respondFinding:responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.respondfinding || '',
                timeStamp: responseData?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}woassessmentheaders`]?.[0]?.timestamp || ''
            }
            setOtherRespondedDetails(updateRespondedeDetails);
            dispatch(updateothereRespondedDetails("UPDATE_OTHER_RESPONDED_DETAILS", updateRespondedeDetails));
            setIsLoading(false);
        }
    }, [responseData]);


    const handleOnchange = (value, name,) => {
        setOtherRespondedDetails((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };
            return updatedData;
        });
    };

    const handleRepairTypeChange = (event) => {
        handleOnchange(event.target.value, "selectedPartsRequired");
    };

    const handleAssetTakenOutChange = (event) => {
        handleOnchange(event.target.value, "selectedAssetTakenOut");
    };

  // Fetch vendor details and create a mapping of vendorId to vendorName
  const getVendorDetails = async () => {
    try {
      const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
      const vendorMap = new Map(vendorDetails.map((v) => [v.id, v.vendorname]));
      setVendorIdToLabelMap(vendorMap);
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };

  // Map response data to get the correct vendor ID
  const getVendorId = () => {
    if (serviceType === "fem" && categoryType === "Scheduled") {
      return responseData?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "bem" && categoryType === "Scheduled") {
      return responseData?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "fem" && categoryType === "Unscheduled") {
      return responseData?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    } else if (serviceType === "bem" && categoryType === "Unscheduled") {
      return responseData?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || responseData?.vendorId;
    }
    return null; // Default to null if no match
  };

  // Set the vendor name based on the vendor ID and the map
  useEffect(() => {
    getVendorDetails(); // Fetch vendor details when component mounts
  }, []);

  useEffect(() => {
    const vendorId = getVendorId();
    const vendorName = vendorIdToLabelMap.get(vendorId) || "";
    setVendorName(vendorName);
    dispatch(getWebFormVendorName("GET_WEBFORM_VENDORNAME",vendorName))
  }, [vendorIdToLabelMap, serviceType, categoryType, responseData]);

    // Update parent when any field changes
    useEffect(() => {
        
        onOtherDetailsChange(otherRespondedDetails);
    }, [otherRespondedDetails?.assessmentId, otherRespondedDetails?.selectedPartsRequired, otherRespondedDetails?.selectedAssetTakenOut, otherRespondedDetails?.outsourceRespondRemarks,otherRespondedDetails?.respondFinding]);
    

    return (
        <DefaultCard>
            <PageLoader open={isLoading} />
            <Typography variant='title2'>
                Other Responded Details
            </Typography>
            <Box mb={3} />
            <Grid container gap={3}>
                <Grid item xs={12} md={2} sm={3}>
                    <CustomTextField
                      label={"Vendor"}
                      id={"vendor"}
                      name={"vendor"}
                      onChange={(e) => handleOnchange(e, "vendor")}
                      value={vendorName || responseData?.vendorname || ""}
                      disabled={true || locationState?.isViewMode || checkstatus}
                    />
                  </Grid>
                <Grid item xs={12} md={2} sm={3}>
                    <CustomTextArea
                        label="Respond Finding"
                        id="respondFinding"
                        value={otherRespondedDetails?.respondFinding || ""}
                        onChange={(e) => handleOnchange(e, "respondFinding")}
                        disabled={locationState?.isViewMode || checkstatus}
                        isMandatoryField={categoryType === "Scheduled" ? false :true}
                        error={responderrorstate}
                        helperText={responderrormessage}
                    />
                </Grid>

                {/* <Grid item xs={12} md={1.4} sm={3}>
                    <FormControl>
                        <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                            Parts Required
                        </Typography>
                        <RadioGroup
                            row
                            name="selectedPartsRequired"
                            onChange={handleRepairTypeChange}
                            value={otherRespondedDetails?.selectedPartsRequired || ""}
                            aria-required={true}
                        >
                            <FormControlLabel value="yes" control={<Radio />} label="Yes" disabled={ true || locationState?.isViewMode} />
                            <FormControlLabel value="no" control={<Radio />} label="No" disabled={true || locationState?.isViewMode} />
                        </RadioGroup>
                    </FormControl>
                </Grid> */}
                <Grid item xs={12} md={2} sm={3}>
                    <FormControl>
                        <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                            Asset Taken Out from Location
                        </Typography>
                        <RadioGroup
                            row
                            name="selectedAssetTakenOut"
                            onChange={handleAssetTakenOutChange}
                            value={otherRespondedDetails?.selectedAssetTakenOut || ""}
                            aria-required={true}
                        >
                            <FormControlLabel value="yes" control={<Radio />} label="Yes" disabled={locationState?.isViewMode || checkstatus} />
                            <FormControlLabel value="no" control={<Radio />} label="No" disabled={locationState?.isViewMode || checkstatus} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={2} sm={3}>
                    <CustomTextArea
                        label="Outsource Respond Remarks"
                        id="outsourceRespondRemarks"
                        value={otherRespondedDetails?.outsourceRespondRemarks}
                        onChange={(e) => handleOnchange(e, "outsourceRespondRemarks")}
                        disabled={locationState?.isViewMode || checkstatus}
                        error={errorState}
                        helperText={errorMesaage}
                        isMandatoryField={true}
                        />
                </Grid>
                
            </Grid>
        </DefaultCard>
    );
};

export default React.memo(OtherRespondedDetailsEditForm);